import styled from '@emotion/styled';
import { MenuItem } from '@material-ui/core';

export const QuickActionMenuItemStyled = styled(MenuItem)`
  &:hover {
    background-color: #ccedfa !important;
  }
`;

export const QuickActionMenuItemIcon = styled(MenuItem)`
  padding-left: 0px !important;
  &:hover {
    background-color: #ccedfa !important;
  }
`;
